import { Svg, Path } from "@react-pdf/renderer";
export const MedicineLogo = (): JSX.Element => {
	return (
		<Svg width="15" height="15" viewBox="0 0 30 30">
			<Path
				d="M9.258 6.036V0h8v6.036L22.517 3l4 6.928-5.259 3.036L26.517 16l-4 6.928-5.259-3.036V26h-8v-6.108L4 22.928 0 16l5.258-3.036L0 9.928 4 3l5.258 3.036z"
				fill="#E02623"
				fill-rule="evenodd"
			/>
		</Svg>
	);
};
